// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"116":"f4eff7deb4d1c88a5c31","511":"8bcb34d9c9da3274a941","958":"c80e795e20236f0b0c8e"}[chunkId] + ".js";
};